import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import bookingsReducer from './bookingsSlice';
import cartReducer from './cartSlice';
import serviceReducer from './serviceSlice';
import addressReducer from './addressSlice';
import couponReducer from './couponSlice';
import favoritesReducer from './favoritesSlice';
import { useDispatch } from 'react-redux';

const store = configureStore({
  reducer: {
    auth: authReducer,
    bookings: bookingsReducer,
    cart: cartReducer,
    service: serviceReducer,
    address: addressReducer,
    coupon: couponReducer,
    favorites: favoritesReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;

export const useAppDispatch = () => useDispatch<AppDispatch>();

export default store;